import React from 'react'
import { InputNumber } from 'primereact/inputnumber'
import { InputText } from 'primereact/inputtext'
import { InputTextarea } from 'primereact/inputtextarea'
import { InputMask } from 'primereact/inputmask'
import { Label, FormGroup } from 'reactstrap'

import './CustomInputs.css'

export const CustomInputNumber = ({
  label,
  value,
  onChange,
  name,
  disabled,
  currency,
  maxFractionDigits,
  placeholder,
  errorMess,
  mode,
  minFractionDigits,
  locale,
  prefix,
  suffix,
  useGrouping,
  borderBottomOnly,
  className,
  min,
  max,
  step,
}) => {
  /**
   * onValueChange fix setting auto suggested value / gets ignored otherwise
   */
  const originalOnChange = (e) => {
    return onChange({
      ...e,
      persist: e.originalEvent.persist,
      target: { name, value: e.value },
    })
  }

  return (
    <FormGroup>
      {label ? <Label className='d-block'>{label}</Label> : null}
      <InputNumber
        onValueChange={onChange}
        value={value}
        onChange={originalOnChange}
        name={name}
        prefix={prefix}
        suffix={suffix}
        locale={locale}
        disabled={disabled}
        currency={currency}
        useGrouping={useGrouping}
        mode={mode}
        maxFractionDigits={maxFractionDigits}
        minFractionDigits={minFractionDigits}
        placeholder={placeholder}
        style={{ width: '100%', border: errorMess ? '1px solid red' : '' }}
        className={`${borderBottomOnly ? 'border-bottom-only-number-prime p-inputtext-sm ' : 'p-inputtext-sm '}${
          className || ''
        }`}
        min={min}
        max={max}
        step={step}
      />
      <small className='text-danger d-block'>{errorMess}</small>
    </FormGroup>
  )
}

export const CustomInputText = React.forwardRef((props, ref) => {
  return (
    <FormGroup>
      {props.label ? <Label className='d-block mb-2'>{props.label}</Label> : null}
      <InputText
        ref={ref}
        value={props.value}
        onChange={props.onChange}
        type={props.password && 'password'}
        name={props.name}
        disabled={props.disabled}
        placeholder={props.placeholder}
        style={{ width: '100%', border: props.errorMess ? '1px solid red' : '' }}
        className={`${props.borderBottomOnly ? 'border-bottom-only-text-prime p-inputtext-sm ' : 'p-inputtext-sm '}${
          props.className || ''
        }`}
      />
      <small className='text-danger d-block'>{props.errorMess}</small>
    </FormGroup>
  )
})

export const CustomTextarea = React.forwardRef((props, ref) => {
  return (
    <FormGroup>
      {props.label ? <Label className={`d-block`}>{props.label}</Label> : null}
      <InputTextarea
        rows={props.rows}
        ref={ref}
        value={props.value}
        onChange={props.onChange}
        name={props.name}
        disabled={props.disabled}
        placeholder={props.placeholder}
        style={{ width: '100%', border: props.errorMess ? '1px solid red' : '' }}
      />
      <small className='text-danger d-block'>{props.errorMess}</small>
    </FormGroup>
  )
})

export const CustomInputMask = (props) => {
  return (
    <FormGroup>
      {props.label && <Label className='d-block mb-2'>{props.label}</Label>}
      <InputMask
        name={props.name}
        mask='(999) 999-9999'
        value={props.value}
        onChange={props.onChange}
        placeholder={props.placeholder}
        disabled={props.disabled}
        className={'p-inputtext-sm'}
        style={{ width: '100%', border: props.errorMess ? '1px solid red' : '' }}
      />
      <small className='text-danger d-block'>{props.errorMess}</small>
    </FormGroup>
  )
}
